import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { IconButton, Tooltip } from "@mui/material";

export interface FieldHintProps {
  /** Already-translated hint text. One sentence, plain clinical language. */
  text: string;
  "data-testid"?: string;
}

/**
 * A small info icon carrying a short hint on hover or focus.
 *
 * Used for fields whose meaning is guessable but occasionally mistaken. Fields
 * that are genuinely ambiguous — where picking the wrong one records the wrong
 * clinical fact — get always-visible helper text instead, because a hint nobody
 * hovers over does not prevent the mistake.
 *
 * An IconButton rather than a bare icon so the hint is reachable by keyboard and
 * by tap, not mouse-only.
 */
export const FieldHint: React.FC<FieldHintProps> = ({ text, "data-testid": testId }) => (
  <Tooltip title={text} enterTouchDelay={0} leaveTouchDelay={5000}>
    {/* `primary` rather than the default action grey: at this size the muted
        icon was almost invisible against the dialog background. */}
    <IconButton size="small" color="primary" aria-label={text} data-testid={testId}>
      <InfoOutlinedIcon fontSize="small" />
    </IconButton>
  </Tooltip>
);
